import {licenseService} from '../services/service-factory';

export default {
  data: function() {
    return {
      licenseService: undefined
    };
  },
  created: function() {
    this.licenseService = licenseService;
  }
};